import { ReactNode, useEffect, useState } from 'react';
import { canBrowserPlayMediaType, getFileExtension, getMimeTypeFromExtension } from 'utils/utils';

interface AppAudioPlayerProps {
  url?: string;
  fileName?: string;
  mimeType?: string;
  className?: string;
  fallback?: ReactNode;
}

export function AppAudioPlayer({ url, fileName, mimeType, className, fallback }: AppAudioPlayerProps) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [url, fileName, mimeType]);

  const finalMimeType = mimeType || (fileName ? getMimeTypeFromExtension(getFileExtension(fileName), 'audio') : '');
  const canPlayAudio = !finalMimeType || canBrowserPlayMediaType(finalMimeType, 'audio');
  const audioRenderKey = [url || '', fileName || '', finalMimeType || ''].join('::');

  if (hasError || !url || !canPlayAudio) {
    return <>{fallback}</>;
  }

  const sourceProps: { src: string; type?: string } = { src: url };
  if (finalMimeType) {
    sourceProps.type = finalMimeType;
  }

  return (
    <audio key={audioRenderKey} controls className={className} onError={() => setHasError(true)}>
      <source {...sourceProps} />
      {fallback}
    </audio>
  );
}
